<div class="overLayDiv active"></div>
<div id="rightSideBar">
    <form [formGroup]="createDetourForm" novalidate>
        <div class="rightSidePanel z-9999 active" style="z-index: 99999;">
            <header class="panel-header">
                <div class="viewDemo title-and-video">
                    <h2>{{'add_detour' | translate:param}}</h2>
                </div>            
                <div class="panel-left-btn">
                    <button type="button" class="btn eod-btn-primary mr-2" [ngClass]="{ 'disabled': disableSubmitButton || !this.createDetourForm.dirty}" 
                        (click)="fnOnSubmitDetour()">
                       {{ 'label_save' | translate: param }}
                    </button>
                    <button type="button" class="btn eod-btn-outline-warning" (click)="fnClosePanel()">
                        {{ 'label_close' | translate: param }}
                    </button>
                </div>
            </header>
            <div class="eod-panel-body">
                <div class="block mt-2 padding-top-25 ">
                    <div class="row">
                        <div class="input-group w-50pc">
                            <input type="text" class="form-control " formControlName="detour"
                            dynamicDigitBeforeAndDynamicDigitAfterDecimalNumber  [beforeDecimal]="6" [afterDecimal]="2"
                                [ngClass]="{'has-value':createDetourForm.controls.detour.value}">
                            <label for="FilterBy">{{'enter_detour' | translate:param}}<span>*</span></label>
                            <div *ngIf="createDetourForm.controls.detour.invalid && isDetourFormSubmitted"
                                class="alert-danger">
                                <span *ngIf="createDetourForm.controls.detour.errors.required">
                                    <b>{{ "label_Required" | translate: param }}</b>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="row margin-top-30">
                        <div class="input-group">
                            <input type="text" class="form-control" formControlName="detourJustificationNotes"
                                maxlength="200"
                                [ngClass]="{'has-value':createDetourForm.controls.detourJustificationNotes.value}">
                            <label for="ExpenseCategory">{{'enter_justification_notes' | translate:param}}<span>*</span></label>
                            <div *ngIf="createDetourForm.controls.detourJustificationNotes.invalid && isDetourFormSubmitted"
                                class="alert-danger">
                                <span *ngIf="createDetourForm.controls.detourJustificationNotes.errors.required
                                     || createDetourForm.controls.detourJustificationNotes.value.trim()==''">
                                    <b>{{ "label_Required" | translate: param }}</b>
                                </span>
                            </div>
                            <p class="text-right">
                                <small><span
                                        [ngClass]="{'color-red': createDetourForm.controls.detourJustificationNotes.value &&
                                    createDetourForm.controls.detourJustificationNotes.value.length > 190 }">{{createDetourForm.controls.detourJustificationNotes.value
                                        ?
                                        createDetourForm.controls.detourJustificationNotes.value.length : 0}}</span>
                                    /
                                    200
                                </small>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>